<template>
  <div>
    <PersonList :persons="persons" v-if="persons"/>
    <FixedPopup :dorms="popupDorms" v-if="popupDorms && popupDorms.length > 0"/>
  </div>
</template>

<script>
import PersonList from '@/components/PersonList'
import FixedPopup from '@/components/FixedPopup'
import axios from 'axios'

export default {
  name: 'PersonDistinctGender',
  components: {
    PersonList,
    FixedPopup
  },
  metaInfo () {
    return {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: this.pageTitle,
      meta: [
        { vmid: 'description', name: 'description', content: this.pageDescription },
        { vmid: 'keywords', name: 'keywords', content: this.pageKeywords }
      ],
      link: [
        { vmid: 'canonical', rel: 'canonical', href: this.url }
      ]
    }
  },
  data () {
    return {
      url: '',
      persons: null,
      popupDorms: null,
      errors: [],
      gender: '',
      typeID: null,
      district: null,
      directors: [
{
      popularity: 6.159,
      known_for_department: "Directing",
      name: "P. S. Keerthana",
      id: 238025,
      profile_path: "/cxGh4lJW2SqQUs4tvW1W7eOtQNI.jpg",
      adult: false,
	  gender: 1
},
{
      popularity: 2.283,
      known_for_department: "Directing",
      gender: 1,
      id: 929825,
      profile_path: "/84rc8I3Wf5zkCWGMNeTtmRekHW0.jpg",
      adult: false,
      name: "Ava DuVernay"
},
{
      popularity: 1.721,
      known_for_department: "Directing",
      name: "Kathryn Bigelow",
      id: 14392,
      profile_path: "/llfsTIvItT7IEmX5qK1qUX0dbqc.jpg",
      adult: false,
      gender: 1
},
{
      popularity: 1.094,
      known_for_department: "Directing",
      name: "Marielle Heller",
      id: 177532,
      profile_path: "/A3A0SNu6nIQJQk7P5wx3vFKcgDW.jpg",
      adult: false,
      gender: 1
},
    {
      popularity: 0.909,
      known_for_department: "Directing",
      name: "Jane Campion",
      id: 10757,
      profile_path: "/kMhbtZ63q0VfgzYPN60wix63zTK.jpg",
      adult: false,
      gender:1
    },
    {
      popularity: 0.995,
      known_for_department: "Directing",
      name: "Karyn Kusama",
      id: 54025,
      profile_path: "/d8jLYxsHkoPJiGXvps9SD7zVdAc.jpg",
      adult: false,
      gender: 1
    },
    {
      popularity: 0.828,
      known_for_department: "Directing",
      name: "Autumn de Wilde",
      gender: 1,
      id: 937147,
      profile_path: "/8KheaszjZvQlPNuTpmLHEf5ZfcP.jpg",
      adult: false,
    },
    {
      popularity: 0.78,
      known_for_department: "Directing",
      name: "Rosemary Rodriguez",
      id: 176794,
      profile_path: "/7axbNQacZRGusat0ya7plPGizZL.jpg",
      adult: false,
      gender: 1
    },    
    {
      popularity: 1.008,
      known_for_department: "Directing", //"Camera",
      name: "Kirsten Johnson",
      id: 117841,
      profile_path: "/tOMNmn03d9bWuXW0nO3OsWZFKql.jpg",
      adult: false,
      gender: 1
    },
    {
      popularity: 0.6,
      known_for_department: "Directing", //"Writing",
      name: "Anahita Ghazvinizadeh",
      id: 1450371,
      profile_path: "/uCzXKrU5sHLs8Ul3dFeoTJXSk2J.jpg",
      adult: false,
      gender: "genre"
    },
    {
      popularity: 0.6,
      known_for_department: "Directing",
      name: "Kitty Green",
      id: 1731915,
      profile_path: "/kr1UsBSbBKYOrFYFe7al4HO3IYh.jpg",
      adult: false,
      gender: 1        
    },
    {
       popularity: 1.932,
      known_for_department: "Directing",
      name: "Penelope Spheeris",
      id: 58448,
      profile_path: "/7juDUTAEyAKKfDmkOD9q24kjrei.jpg",
      adult: false,
      gender: 1
    },
    {
      popularity: 1.635,
      known_for_department: "Directing",
      name: "Susanne Bier",
      id: 1011,
      profile_path: "/tVp2J7hMAgJnaXtQojFN3VTVYaY.jpg",
      adult: false,
      gender:1
    },
    {
      popularity: 1.415,
      known_for_department: "Directing",
      name: "Lois Weber",
      id: 1037794,
      profile_path: "/63gtctinFH20Gt9MnZ0tiB6iE0S.jpg",
      adult: false,
      gender:1
    },
    {
      popularity: 1.4,
      known_for_department: "Directing",
      name: "Amy Heckerling",
      gender: 1,
      id: 57434,
      profile_path: "/hIc3bQxLOPAcpGJ1CVFuzpzJRZ0.jpg",
      adult: false,
    },
    {
       popularity: 1.392,
      known_for_department: "Directing",
      name: "Sam Taylor-Johnson",
      id: 1137903,
      profile_path: "/4iWEBM7B4nANVZcRaID9XHo4tPl.jpg",
      adult: false,
      gender: 1
    },
    {
       popularity: 1.356,
      known_for_department: "Directing",
      name: "Joan Micklin Silver",
      id: 97646,
      profile_path: "/dLF3GSlCHT0PSnA7DaYU85Sl4VU.jpg",
      adult: false,
      gender:1
    },
    {
      popularity: 1.214,
      known_for_department: "Directing",
      name: "Joanna Hogg",
      gender: 1,
      id: 105435,
      profile_path: "/ctW1b4JnA3srwfPe1ZIt6TX42Yh.jpg",
      adult: false,
    },
    {
      popularity: 1.094,
      known_for_department: "Directing",
      name: "Kimberly Peirce",
      id: 2836,
      profile_path: "/lRnwxog6xUZV26mxCVuMFM006CV.jpg",
      adult: false,
      gender: 1
    },
    {
      popularity: 1.094,
      known_for_department: "Directing",
      name: "Barbara Hammer",
      id: 1184106,
      profile_path: "/3U00L0JoPwG56CYUNxVYeXA14Gm.jpg",
      adult: false,
      gender: 1
    },
    {   
      popularity: 0.6,
      known_for_department: "Directing",
      name: "Gurinder Chadha",
      id: 6220,
      profile_path: "/giMqMKMIu9e9ieQoHRoqZqnWGwr.jpg",
      adult: false,
      gender:1
    },
    {
       popularity: 0.6,
      known_for_department: "Directing",
      name: "Shirley Clarke",
      id: 227525,
      profile_path: "/xeg821qKd2VgGlh9szKsa8PDxPq.jpg",
      adult: false,
      gender: 1
    },
    {
      popularity: 1.534,
      known_for_department: "Directing",
      name: "Agnieszka Holland",
      id: 1128,
      profile_path: "/t7OOYOMIre88LLiWYepg8XnF9FD.jpg",
      adult: false,
      gender: 1
    },
    {
       popularity: 1.532,
      known_for_department: "Directing",
      name: "Claire Denis",
      gender: 1,
      id: 9888,
      profile_path: "/zKR7pmegNQDjWqeWv7JNvHqJ2l5.jpg",
      adult: false,
    },
    {
      popularity: 1.4,
      known_for_department: "Directing",
      name: "Roxann Dawson",
      id: 34396,
      profile_path: "/uXfTzGZLlJYhBvkRnZo0zV6jTwU.jpg",
      adult: false,
      gender: 1
    },
    {
       popularity: 1.4,
      known_for_department: "Directing",
      name: "Nora Twomey",
      id: 96677,
      profile_path: "/pdWB95taGC55C4rOgmsPM59gBSK.jpg",
      adult: false,
      gender: 1
    },
{
      popularity: 1.4,
      known_for_department: "Directing",
      name: "Sally Potter",
      id: 57206,
      profile_path: "/7hzuG6C7GD8gbBtqdoHOfwQ3P5M.jpg",
      adult: false,
      gender: 1
},
    {
      popularity: 1.22,
      known_for_department: "Directing",
      name: "Maya Deren",
      id: 96813,
      profile_path: "/vr0sJYfJR71xptqVEC5nIMJQ4mt.jpg",
      adult: false,
      gender: 1
    },
    {
      popularity: 1.176,
      known_for_department: "Directing",
      name: "Mira Nair",
      gender: 1,
      id: 6495,
      profile_path: "/nhlVK31Lom6xvzVz3wYlVAE5sPm.jpg",
      adult: false,
    },
    {
       popularity: 1.127,
      known_for_department: "Directing",
      name: "Agnès Varda",
      gender: 1,
      id: 6817,
      profile_path: "/8XKM6DCVcH5RsgIRh9mwVaEM0YB.jpg",
      adult: false,
    },
    { 
      popularity: 0.725,
      known_for_department: "Directing",
      name:"Chantal Akerman",
      gender: 1,
      id: 130030,
      profile_path: "/kJ6WAcJ3nfXQR4WhXto89tjigZh.jpg",
      adult: false,
      },
{
       popularity: 0.694,
      known_for_department: "Directing",
      name: "Marleen Gorris",
      id: 13496,
      profile_path: "/sSVUF5IE4nF4CCLzkwCfRmQz1Ws.jpg",
      adult: false,
      gender:1
},     
{
      popularity: 0.6,
      known_for_department: "Directing",
      name: "Claudia Weill",
      id: 167687,
      profile_path: "/7SkR4W2bRYr6MJoSrVHdpGPJK9J.jpg",
      adult: false,
      gender: 1
},      
    {
      popularity: 0.6,
      known_for_department: "Directing",
      name: "Irene Lusztig",
      id: 1465906,
      profile_path: null,
      adult: false,
      gender: 1
},
{
      popularity: 0.6,
      known_for_department: "Directing",
      gender: 1,
      id: 1961679,
      profile_path: null,
      adult: false,
      name: "Adina Pintilie"
},
    {
       popularity: 1.96,
      known_for_department: "Directing",
      name: "Catherine Hardwicke",
      id: 19850,
      profile_path: null,
      adult: false,
      gender: 1
    },
    {
       popularity: 0.98,
      known_for_department: "Directing",
      name: "Mary Harron",
      id: 16378,
      profile_path: null,
      gender: 1
    },
    {
      popularity: 1.094,
      known_for_department: "Directing",
      name: "Martha Coolidge",
      id: 63713,
      profile_path: null,
      adult: false,
      gender: 1
    },
{
    popularity: 1.094,
      known_for_department: "Directing",
      name: "Patricia Riggen",
      id: 437833,
      profile_path: null,
      adult: false,
      gender: 1
},
{
      popularity: 1.528,
      known_for_department: "Directing",
      name: "Gillian Armstrong",
      gender: 1,
      id: 58094,
      profile_path: null,
      adult: false,
},
{
       popularity: 0.6,
      known_for_department: "Directing",
      name: "Julie Dash",
      id: 142603,
      profile_path: null,
      adult: false,
      gender: 1
},
{     popularity: 0.6,
      known_for_department: "Directing",
      name: "Diane Obomsawin",
      gender: 1,
      id: 1523900,
      profile_path: null,
      adult: false,
},
{
    popularity: 0.6,
      known_for_department: "Directing",
      name: "Alanis Obomsawin",
      id: 940632,
      profile_path: null,
      adult: false,
      gender:1
},
{
       popularity: 0.714,
      known_for_department: "Directing",
      name: "Allison Anders",
      id: 3110,
      profile_path: null,
      adult: false,
      gender: 1
},
{
    popularity: 0.996,
      known_for_department: "Directing",
      name: "Lisa Cholodenko",
      gender: 1,
      id: 75699,
      profile_path: null,
      adult: false,
}
      ],
      writers: [
      {
      popularity: 1.38,
      known_for_department: "Writing",
      gender: 1,
      id: 71551,
      profile_path: "/uToUw9I39wMiBWkCdcYO6gnz4S8.jpg",
      adult: false,
      name: "Lorene Scafaria"
      },

{
      popularity: 1.4,
      known_for_department: "Writing",
      name: "Nora Ephron",
      id: 9248,
      profile_path: "/2DO8ef3VVkcmMX2m0Qfz01IkMl4.jpg",
      adult: false,
      gender: 1
},
{      popularity: 2.933,
      known_for_department: "Writing", //karlar ukesi yonetmeni
      name: "Jennifer Lee",
      id: 1120694,
      profile_path: "/pjZY7hdneR7FLrAT0mXNR6RrPfy.jpg",
      adult: false,
      gender: 1
},
{
      popularity: 1.625,
      known_for_department: "Writing",
      name: "Nancy Meyers",
      gender: 1,
      id: 17698,
      profile_path: "/aK2lYDBYhWU9MJdNV0y1EvXiNo0.jpg",
      adult: false,
},
{
    popularity: 0.707,
      known_for_department: "Writing",
      name: "Nicole Holofcener",
      gender: 1,
      id: 56539,
      profile_path: "/FawkGwho6HwcVr85WCZkyH5lhu.jpg",
      adult: false,
},
{
      popularity: 0.728,
      known_for_department: "Directing",
      name: "Gina Prince-Bythewood",
      id: 71947,
      profile_path: null,
      adult: false,
      gender: 1
}
      ],
      camera: [
{
      popularity: 0.6,
      known_for_department: "Camera",
      name: "Allison Anderson",
      id: 2555568,
      profile_path: null,
      adult: false,
      gender: 1
          }
      ],
      producersFemale: [
{
      popularity: 1.38,
      known_for_department: "Production",
      name: "Barbara Broccoli",
      id: 10666,
      profile_path: "/AhZYRh7lSJj4vXMcHHRzYDe21JA.jpg",
      adult: false,
	    gender: 1
},
    {
      popularity: 3.562,
      known_for_department: "Production",
      name: "Carrie Hilton",
      gender: 1,
      id: 6232,
      profile_path: "/oV6zgHmWq9yfSHJ3gE33Tzpbch6.jpg",
      adult: false,
    },
    {
      popularity: 1.918,
      known_for_department: "Directing",
      name: "Ava Duvernay",
      gender: 1,
      id: 929825,
      profile_path: "/84rc8I3Wf5zkCWGMNeTtmRekHW0.jpg",
      adult: false,
    },    
{
      popularity: 0.6,
      known_for_department: "Production",
	    name: "Bonnie Bruckheimer",
      gender: 1,
      id: 58070,
      profile_path: null,
      adult: false,
},
    {
      popularity: 1.564,
      known_for_department: "Production",
      adult: false,
      id: 935634,
      profile_path: null,
      name: "Nina Jacobson",
      gender: 1
    },
      ],      
      producers: [
{
      popularity: 0.6,
      known_for_department: "Production",
      name: "Sally Potters",
      gender: 0,
      id: 2116382,
      profile_path: null,
      adult: false,
},
{
      popularity: 1.931,
      known_for_department: "Production",
	    name: "Frank Marshall",
      gender: 2,
      id: 664,
      profile_path: null,
      adult: false,
},
    {
      popularity: 1.214,
      known_for_department: "Production",
      name: "Megan Ellison",
      id: 1027025,
      profile_path: null,
      adult: false,
      gender: 1
    },
    {
      popularity: 1.203,
      known_for_department: "Production",
      name: "Jerry Bruckheimer",
      id: 770,
      profile_path: "/vTKQVRrj9vOrKLkPEsXHxmpV9c3.jpg",
      adult: false,
     },
{      popularity: 0.828,
      known_for_department: "Production",
      name: "Arnon Milchan",
      id: 376,
      profile_path: "/b2hBExX4NnczNAnLuTBF4kmNhZm.jpg",
      adult: false,
	    gender: 2
},
{
      popularity: 1.712,
      known_for_department: "Production",
      name: "Scott Rudin",
      id: 2997,
      profile_path: "/zIeKeFgBERBHmabgmqZFmgcxqvO.jpg",
      adult: false,
	    gender: 2
},
{
      popularity: 0.6,
      known_for_department: "Production",
      name: "Irving Thalberg",
      id: 1497,
      profile_path: "/yMR4w6n1L1zGdbTvu85UPVM4ai5.jpg",
      adult: false,
	    gender: 2
},
{
      popularity: 0.6,
      known_for_department: "Production",
      name: "Adolph Zukor",
      id: 13335,
      profile_path: "/h4gkeIGlb8fybIxrPokalu23oFX.jpg",
      adult: false,
	    gender: 2
},
    {
      popularity: 0.6,
      known_for_department: "Production",
      name: "Hal B. Wallis",
      id: 4123,
      profile_path: "/lia6xtKaPDmQ68BArDkqxAFj9go.jpg",
      adult: false,
	    gender: 2
},
{
      popularity: 1.008,
      known_for_department: "Production",
      name: "Sam Spiegel",
      id: 6594,
      profile_path: "/zM5qW22AbzXUE626uZD0OXNzDWD.jpg",
      adult: false,
	    gender: 2
},
    {
      popularity: 0.6,
      known_for_department: "Production",
      name: "Harry Cohn",
      id: 29341,
      profile_path: "/8W9Elna9PhiXUQey32tzzxZSP8J.jpg",
      adult: false,
	    gender: 2
},
{
      popularity: 0.6,
      known_for_department: "Production",
	    name: "Waller Mirisch",
      gender: 2,
      id: 14523,
      profile_path: "/diPKMcQzIfNY2JN8tHxiGl4fsW.jpg",
      adult: false,
},
{
      popularity: 0.6,
      known_for_department: "Production",
      name: "Ed Mirisch",
      id: 2419960,
      profile_path: null,
      adult: false,
	    gender:0
},
{
      popularity: 0.84,
      known_for_department: "Production",
      name: "Jack L. Warner",
      id: 2663,
      profile_path: null,
      adult: false,
	    gender: 2
},
{
      popularity: 1.214,
      known_for_department: "Production",
      name: "Christopher H. Warner",
      id: 1932098,
      profile_path: null,
      adult: false,
	    gender: 2
},
{
      popularity: 0.6,
      known_for_department: "Production",
	    name: "Warner Bros",
      gender: 0,
      id: 2075115,
      profile_path: null,
},
{
      popularity: 1.646,
      known_for_department: "Production",
      name: "David Heyman",
      id: 10968,
      profile_path: null,
      adult: false,
	    gender: 2
},
{
      popularity: 0.84,
      known_for_department: "Production",
	    name: "Darryl F. Zanuck",
      gender: 2,
      id: 8502,
      profile_path: null,
      adult: false,
},
{
      popularity: 0.828,
      known_for_department: "Production",
      name: "Richard D. Zanuck",
      id: 1297,
      profile_path: null,
      adult: false,
	    gender: 2
},
{
      popularity: 0.6,
      known_for_department: "Production",
	    name: "Harrison Zanuck",
      gender: 0,
      id: 41281,
      profile_path: null,
      adult: false,
},
{
      popularity: 1.094,
      known_for_department: "Production",
      name: "Lili Fini Zanuck",
      id: 5707,
      profile_path: null,
      adult: false,
	    gender: 1
},
{
      popularity: 0.6,
      known_for_department: "Production",
	    name: "John Fairbanks",
      gender: 2,
      id: 2280266,
      profile_path: null,
      adult: false,
},
{
      popularity: 0.6,
      known_for_department: "Production",
      name: "Jill Fairbanks",
      id: 2545545,
      profile_path: null,
      adult: false,
	    gender: 0
},
{
      popularity: 0.6,
      known_for_department: "Production",
      name: "Jerry Fairbanks",
      id: 118221,
      profile_path: null,
      adult: false,
	    gender: 0
},
{
      popularity: 1.856,
      known_for_department: "Production",
	    name: "Avi Arad",
      gender: 2,
      id: 7626,
      profile_path: null,
      adult: false
},
{
      popularity: 1.094,
      known_for_department: "Production",
	    name: "Frank Capra, Jr.",
      gender: 2,
      id: 69599,
      profile_path: null,
      adult: false
},
{
      popularity: 0.828,
      known_for_department: "Production",
      name: "Albert R. Broccoli",
      id: 9861,
      profile_path: null,
      adult: false,
	gender: 2
},
{
      popularity: 0.6,
      known_for_department: "Production",
	    name: "Tony Broccoli",
      gender: 0,
      id: 1984264,
      profile_path: null,
      adult: false,
},
{
      popularity: 0.6,
      known_for_department: "Production",
	    name: "Rika Broccoli",
      gender: 0,
      id: 1984263,
      profile_path: null,
      adult: false,
},
{
      popularity: 0.6,
      known_for_department: "Production",
	    name: "Carl Laemmle Jr.",
      gender: 2,
      id: 1557,
      profile_path: null,
      adult: false,
},
{
      popularity: 0.6,
      known_for_department: "Production",
	    name: "Eugene J. Zukor",
      gender: 0,
      id: 1265587,
      profile_path: null,
      adult: false,
},
{
      popularity: 0.828,
      known_for_department: "Production",
      name: "Konstantin Ernst",
      id: 23435,
      profile_path: null,
      adult: false,
	    gender:2
},
{
      popularity: 0.6,
      known_for_department: "Production",
      name: "Howard Hughes",
      id: 13348,
      profile_path: null,
      adult: false,
	    gender: 2
},
{
      popularity: 0.6,
      known_for_department: "Production",
	    name: "Terri Howard-Hughes",
      gender: 0,
      id: 1761144,
      profile_path: null,
      adult: false
},
{
      popularity: 0.954,
      known_for_department: "Production",
      name: "Bruce Berman",
      id: 1296,
      profile_path: null,
      adult: false,
	    gender:2
},
{
      popularity: 0.6,
      known_for_department: "Production",
      name: "Pandro S. Berman",
      id: 30174,
      profile_path: null,
      adult: false,
	    gender: 2
},
{
      popularity: 0.6,
      known_for_department: "Production",
	    name: "Al Berman",
      gender: 0,
      id: 1891750,
      profile_path: null,
      adult: false,
},
{
      popularity: 0.6,
      known_for_department: "Production",
	    name: "Robert W. Evans",
      gender: 0,
      id: 2443109,
      profile_path: null,
      adult: false
},
    {
      popularity: 0.6,
      known_for_department: "Production",
      name: "Wallis Nicita",
      id: 12847,
      profile_path: null,
      adult: false,
	    gender: 2
},
    {
      popularity: 0.98,
      known_for_department: "Production",
	    name: "Rob Wallis",
      gender: 0,
      id: 592936,
      profile_path: null,
      adult: false
},
{
      popularity: 0.6,
      known_for_department: "Production",
      name: "Andrew Mirisch",
      id: 1568718,
      profile_path: null,
      adult: false,
	    gender: 0
},
    {
      popularity: 0.6,
      known_for_department: "Production",
      name: "Marvin E. Mirisch",
      id: 1895557,
      profile_path: null,
      adult: false,
      known_for: [],
      gender: 0
    },
    {
      popularity: 0.6,
      known_for_department: "Production",
      name: "Richard Mirisch",
      id: 62740,
      profile_path: null,
      adult: false,
	    gender: 0
},
{
      popularity: 0.6,
      known_for_department: "Production",
      name: "David Mirisch",
      id: 2419959,
      profile_path: null,
      adult: false,
	  gender: 0
},
{
      popularity: 0.6,
      known_for_department: "Production",
      name: "Robert Mirisch",
      id: 1388446,
      profile_path: null,
      adult: false,
	  gender: 2
},
{
      popularity: 0.6,
      known_for_department: "Production",
	    name: "Marvin Mirisch",
      gender: 0,
      id: 1817049,
      profile_path: null,
      adult: false,
},
    
      ],
      soundMale: [
    {
      popularity: 0.6,
      known_for_department: "Sound",
      name: "Rodriguez",
      id: 1133582,
      profile_path: "/cFxLnQIg146h6DOcVLXIvnW2rG9.jpg",
      adult: false,
      gender: 2
    },   
    {
      popularity: 0.6,
      known_for_department: "Sound",
	    name: "Ramiz Mirishli",
      gender: 0,
      id: 2048837,
      profile_path: "/rHHlfJ2UKnRsbYuhDx8dsPBl751.jpg",
      adult: false,
    },         
{
      popularity: 0.6,
      known_for_department: "Sound",
      name: "Dirk Reichardt",
      id: 48503,
      profile_path: null,
      adult: false,
      gender: 2,
},
{
      popularity: 0.6,
      known_for_department: "Sound",
      name: "Mirist Egal",
      gender: 0,
      id: 1950435,
      profile_path: null,
      adult: false,
    },
    {
      popularity: 0.6,
      known_for_department: "Sound",
	    name: "David Heyman",
      gender: 0,
      id: 2434518,
      profile_path: null,
      adult: false,
	    gender: 2
},
{
      popularity: 0.6,
      known_for_department: "Sound",
	    name: "Nazim Mirishli",
      gender: 0,
      id: 2069655,
      profile_path: null,
      adult: false,
},
    {
      popularity: 0.6,
      known_for_department: "Sound",
      name: "Sam Spiegel",
      gender: 0,
      id: 1344091,
      profile_path: null,
      adult: false,
    },
    {
      popularity: 0.6,
      known_for_department: "Sound",
      name: "Harris Johns",
      gender: 0,
      id: 544759,
      profile_path: null,
      adult: false,
    }
      ],
      art: [
{
        popularity: 0.6,
      known_for_department: "Art",
      name: "Eric Reichardt",
      id: 113832,
      profile_path: null,
      adult: false,
      gender:0
}          
      ],
  soundFemale: [],
  visualFemale: [
    {
      popularity: 0.6,
      known_for_department: "Visual Effects",
      name: "Michael Ralla",
      id: 2124103,
      profile_path: null,
      adult: false,
      gender: 1
    },    
  ],
  visualMale:[
    {
      popularity: 0.6,
      known_for_department: "Visual Effects",
      name: "John Nelson",
      id: 1456374,
      profile_path: null,
      adult: false,
      gender: 2
    },
    {
      popularity: 0.6,
      known_for_department: "Visual Effects",
      name: "Joe Bauer",
      id: 1404731,
      profile_path: null,
      adult: false,
      gender: 2
    },
{
      popularity: 0.98,
      known_for_department: "Visual Effects",
      name: "Stephane Ceretti",
      id: 1327025,
      profile_path: null,
      adult: false,
      gender:2    
},
    {
      popularity: 0.6,
      known_for_department: "Visual Effects",
      name: "Marco Maldonado",
      id: 1422415,
      profile_path: null,
      adult: false,
      gender:2
    },
{
      popularity: 0.6,
      known_for_department: "Visual Effects",
      name: "Jerome Chen",
      id: 42261,
      profile_path: null,
      adult: false,
      gender: 2   
},
{
      popularity: 0.6,
      known_for_department: "Visual Effects",
      name: "Guillaume Rocheron",
      id: 1439094,
      profile_path: null,
      adult: false,
      gender: 2
},
    {
      popularity: 0.6,
      known_for_department: "Visual Effects",
      name: "Richard Stammers",
      id: 1384386,
      profile_path: null,
      adult: false,
      gender:2
    },
    {
      popularity: 0.6,
      known_for_department: "Visual Effects",
      name: "Christopher Townsend",
      id: 1408337,
      profile_path: null,
      adult: false,
      gender:2
    },
    {
      popularity: 0.6,
      known_for_department: "Visual Effects",
      name: "Adam Valdez",
      id: 1049272,
      profile_path: null,
      adult: false,
      gender:2
    },
    {
      popularity: 0.6,
      known_for_department: "Visual Effects",
      name: "Erik Nordby",
      id: 1401589,
      profile_path: null,
      adult: false,
      gender:2
    },       
  ],
editorsMale: [
    {
      popularity: 0.6,
      known_for_department: "Editing",
      name: "Rob Evans",
      id: 2597506,
      profile_path: null,
      adult: false,
	gender: 2
},
   
],
editorsFemale: [
    {
      popularity: 0.828,
      known_for_department: "Editing",
	name: "Rebecca Rodriguez",
      gender: 1,
      id: 72030,
      profile_path: null,
      adult: false,
},
    {
      popularity: 1.4,
      known_for_department: "Editing",
	name: "Veronika Zaplata",
      gender: 1,
      id: 50149,
      profile_path: null,
      adult: false,
},
]
    }
  },
  methods: {
    checkGender () {
      const type = this.$attrs.redirect ? this.$route.params.slug : this.$route.params.type
      if (type && type.includes('erkek')) {
        this.gender = 'Erkek'
        this.typeID = 1
      } else if (type && type.includes('kiz')) {
        this.gender = 'Kız'
        this.typeID = 2
      }
    },
    getPersons () {
    // this.checkGender ()
      let self = this
      var dene = this.$route.params.distinct
      axios
        .get(`/3/person/popular?api_key=a11ac97c6bdb99adc0845654be0902a8&page=1`)
        .then(response => {
           self.persons = []
           if (self.$route.params.district == 'all' || self.$route.params.district == 'actor') {
          self.persons = response.data.results
           } else if (self.$route.params.district == 'directing') {
          self.persons = self.directors
           } else if (self.$route.params.district == 'writing' && self.$route.params.type == 'female') {
          self.persons = self.writers
           } else if (self.$route.params.district == 'producer' && self.$route.params.type == 'female') {
          self.persons = self.producersFemale
           } else if (self.$route.params.district == 'visual' && self.$route.params.type == 'male') {
          self.persons = self.visualMale
           } else if (self.$route.params.district == 'visual' && self.$route.params.type == 'female') {
          self.persons = self.visualFemale
           } else if (self.$route.params.district == 'sound' && self.$route.params.type == 'male') {
          self.persons = self.soundMale
           } else if (self.$route.params.district == 'sound' && self.$route.params.type == 'female') {
          self.persons = self.soundFemale              
           } else if (self.$route.params.district == 'editor' && self.$route.params.type == 'male') {
          self.persons = self.editorsMale
           } else if (self.$route.params.district == 'editor' && self.$route.params.type == 'female') {
          self.persons = self.editorsFemale                                              
           }else {
              response.data.results.forEach(item => {
                  if(item.known_for_department == self.$route.params.distinct) {
                      self.persons.push(item)
                  }
              })
           }

        //  self.district = response.data.district
        //  self.popupDorms = response.data.popups
        })
        .catch(e => {
          this.errors.push(e)
        })
    },
  },
  computed: {
    pageTitle () {
      let title = ''
      if (this.district) {
        if (this.typeID === 1) title = this.district.male_title
        else if (this.typeID === 2) title = this.district.female_title
      }
      return title
    },
    pageDescription () {
      let title = ''
      if (this.district) {
        if (this.typeID === 1) title = this.district.male_description
        else if (this.typeID === 2) title = this.district.female_description
      }
      return title
    },
    pageKeywords () {
      let title = ''
      if (this.district) {
        if (this.typeID === 1) title = this.district.male_keywords
        else if (this.typeID === 2) title = this.district.female_keywords
      }
      return title
    }
  },
  created () {
    this.getPersons()
    this.url = window.location.origin + '/' + this.$route.params.city + '-movies/'
  },
  watch: {
    $route () {
      this.getDorms()
    }
  }
}
</script>

<style lang="scss">
</style>
